import * as React from 'react';
import {connect} from 'react-redux';
import * as FDC3 from 'openfin-fdc3';
import {Identity} from 'openfin/_v2/main';
import {Dispatch} from 'redux';
import {Radio} from '@openfin/desktop-ui';

import {RootState} from '../../../store/State';
import {ChannelData, JoinChannel, MemberInfo} from '../../../store/partials/ChannelManager';

import * as Styles from './ChannelSelector.module.scss';

interface Props {
    systemChannels: ChannelData<FDC3.SystemChannel>[];
    joinChannel: (channel: FDC3.Channel, identity: Identity) => void;
    app: MemberInfo;
}

const ChannelSelectorComponent: React.FC<Props> = React.memo((props) => {
    const {systemChannels, app, joinChannel} = props;

    // A lookup table to translate channel colour to colours specified in design for system channels.
    const colorLookup = {
        '#FF0000': '#F55D5F', // red
        '#FF8000': '#FB8772', // orange
        '#FFFF00': '#DEBA62', // yellow
        '#0000FF': '#5C78FF', // blue
        '#FF00FF': '#C686E5', // purple
        '#00FF00': '#67C1AD' // green
    };

    const getAppChannelName = (member: MemberInfo): string | undefined => {
        if (member.channel && member.channel.type === 'system') {
            return member.channel.visualIdentity.name;
        }
        return undefined;
    };

    return (
        <div className={Styles['channel-selector']}>
            <div className={Styles['option']}>
                <Radio name={`${app.identity.uuid}${app.identity.name}`}
                    defaultChecked={app.channel ? (app.channel.id === FDC3.defaultChannel.id) : false}
                    onChange={() => {
                        joinChannel(FDC3.defaultChannel, app.identity);
                    }}
                />
            </div>
            {systemChannels.map((channel, i) => <div className={Styles['option']} key={i}>
                <Radio name={`${app.identity.uuid}${app.identity.name}`}
                    defaultChecked={getAppChannelName(app) === channel.channel.visualIdentity.name}
                    onChange={() => {
                        joinChannel(channel.channel, app.identity);
                    }}
                    color={colorLookup[channel.channel.visualIdentity.color] || channel.channel.visualIdentity.color}
                />
            </div>)}
        </div>
    );
});

const mapState = (state: RootState) => ({
    systemChannels: Object.values(state.channelManager.channels).filter((x) => x.channel.type === 'system') as ChannelData<FDC3.SystemChannel>[]
});

const mapDispatch = (dispatch: Dispatch) => ({
    joinChannel: (channel: FDC3.Channel, identity: Identity) => {
        dispatch(new JoinChannel(channel, identity));
    }
});

export const ChannelSelector = connect(mapState, mapDispatch)(ChannelSelectorComponent);
